import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { CheckedIcon, UncheckedIcon } from '../../../Icons/Icons'
import './CheckButton.scss'

const CheckButton = ({ value, checked, text, toggle }) => {
  const handleToggle = () => toggle(value)

  return (
    <Fragment>
      <button
        className="check-btn"
        onClick={handleToggle}
      >
        <div className="check-btn-txt">
          {text}
        </div>
        <div className="check-btn-icon">
          {checked && <CheckedIcon />}
          {!checked && <UncheckedIcon />}
        </div>
      </button>
    </Fragment>
  )
}

CheckButton.propTypes = {
  value: PropTypes.any,
  checked: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired
}

export default CheckButton
